<template>
    <footer class="w-100 py-18 px-16 py-sm-24 px-sm-32 hp-bg-color-black-20 hp-bg-color-dark-90">
                    <!-- <div class="row">
                        <div class="col-12 col-xl-8">
                            <p class="hp-badge-text mb-0 text-center hp-text-color-dark-30">Copyright ©{{ year }} Baesnap, All rights Reserved</p>
                        </div>
                    </div> -->
                </footer>
</template>

<script>
    export default {

        data(){
            return{
                year: "",
            }
        },

        mounted(){
            const d = new Date();
            this.year = d.getFullYear();
        }
        
    }
</script>